"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconStarHalfFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8.90644 1.58373C8.53853 0.822405 7.45389 0.823176 7.08706 1.585L5.42131 5.04437L1.88616 5.51861C1.08684 5.62584 0.729363 6.58053 1.26178 7.18637L3.84241 10.1229L3.13969 13.7931C2.9855 14.5984 3.80448 15.2421 4.55057 14.902L7.9974 13.3309L11.4509 14.9023C12.1976 15.2421 13.0165 14.597 12.8609 13.7915L12.1525 10.1228L14.7383 7.18725C15.2718 6.58164 14.9146 5.62591 14.1147 5.51861L10.5787 5.04425L8.90644 1.58373ZM8 11.2331C8.14172 11.2335 8.28338 11.2637 8.41533 11.3238L10.5335 12.2876L10.0966 10.0247C10.0373 9.71761 10.1236 9.40034 10.3303 9.16562L12.0137 7.25466L9.78484 6.95566C9.44857 6.91055 9.15739 6.69961 9.00975 6.39409L8 4.30459V11.2331Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10.9049 1.58347C10.537 0.822137 9.45239 0.82296 9.08557 1.58475L6.78357 6.36536L1.88567 7.02241C1.08631 7.12964 0.728894 8.08436 1.2613 8.69017L4.814 12.7327L3.84513 17.7929C3.69094 18.5982 4.5099 19.2419 5.25601 18.9018L9.99592 16.7414L14.7448 18.9021C15.4915 19.2419 16.3103 18.5968 16.1548 17.7913L15.1779 12.7327L18.7381 8.69105C19.2716 8.08543 18.9144 7.1297 18.1145 7.0224L13.2158 6.36524L10.9049 1.58347ZM10 14.6436C10.1412 14.6442 10.2823 14.6744 10.4138 14.7342L13.8274 16.2874L13.122 12.6346C13.0627 12.3275 13.149 12.0102 13.3558 11.7755L16.0134 8.75846L12.4219 8.27666C12.0856 8.23155 11.7944 8.02062 11.6468 7.71509L10 4.30739V14.6436Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12.9038 1.58347C12.5359 0.822168 11.4513 0.82293 11.0844 1.58475L8.14622 7.68659L1.88567 8.52643C1.08627 8.63366 0.728913 9.58841 1.2613 10.1942L5.78601 15.3428L4.55101 21.7929C4.39681 22.5982 5.21584 23.2419 5.96189 22.9018L11.9948 20.152L18.0389 22.9021C18.7857 23.2419 19.6044 22.5967 19.4489 21.7913L18.2036 15.3427L22.7381 10.1951C23.2716 9.58946 22.9144 8.63372 22.1145 8.52642L15.8531 7.68647L12.9038 1.58347ZM12 18.0542C12.1408 18.055 12.2816 18.0852 12.4127 18.1449L17.1215 20.2874L16.1477 15.2446C16.0884 14.9375 16.1747 14.6202 16.3815 14.3855L20.0134 10.2625L15.0592 9.59789C14.7229 9.55277 14.4318 9.34181 14.2841 9.03632L12 4.30975V18.0542Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M17.3524 2.36604C16.8023 1.2278 15.1807 1.22903 14.6323 2.36795L10.8567 10.2088L2.81929 11.287C1.62431 11.4473 1.08978 12.8746 1.88582 13.7804L7.70705 20.4043L6.11885 28.699C5.88834 29.9029 7.1127 30.8654 8.22819 30.3569L15.9933 26.8175L23.7731 30.3573C24.8896 30.8653 26.1136 29.9008 25.8811 28.6966L24.2797 20.4042L30.1134 13.7817C30.911 12.8763 30.377 11.4474 29.1811 11.287L21.1424 10.2086L17.3524 2.36604ZM16 23.6703C16.2109 23.6713 16.4217 23.7165 16.6182 23.8059L22.3882 26.4313L21.1954 20.2546C21.1067 19.7955 21.2358 19.3211 21.5449 18.9702L26.0202 13.8899L19.9489 13.0754C19.4462 13.008 19.0108 12.6926 18.7901 12.2358L16 6.46234V23.6703Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;